import { Injectable } from '@angular/core';
@Injectable()
export  class PackagePricing {
    private packageDetails : {
        coremonthlyPrice:string;
        coreannualPrice:string;
        trainmonthlyPrice:string;
        trainannualPrice:string;
        retainmonthlyPrice:string;
        retainannualPrice:string;
        jobTrackermonthlyPrice:string;
        jobTrackerannualPrice:string;
        upFront:string;
        maintenanceFee:string;
        engagemonthlyPrice:string;
        engageannualPrice:string;
        promonthlyPrice:string;
        proannualPrice:string;
        currency:string;
    };
    public pricing:Map<String, PackagePricing["packageDetails"]>=
    new Map([
    ["226",        
    {
        'coremonthlyPrice':'299',
        'coreannualPrice':'3,200',
        'trainmonthlyPrice':'449',
        'trainannualPrice':'4,850',
        'retainmonthlyPrice':'215',
        'retainannualPrice':'2,350',
        'jobTrackermonthlyPrice':'60',
        'jobTrackerannualPrice':'630',
        'upFront':'3,200',
        'maintenanceFee':'1,000',
        'engagemonthlyPrice':'449',
        'engageannualPrice':'4,850',
        'promonthlyPrice':'549',
        'proannualPrice':'6,000',
        'currency':'pound'
    }],
    ["82",
    {
        'coremonthlyPrice':'349',
        'coreannualPrice':'3,700',
        'trainmonthlyPrice':'499',
        'trainannualPrice':'5,400',
        'retainmonthlyPrice':'245',
        'retainannualPrice':'2,650',
        'jobTrackermonthlyPrice':'65',
        'jobTrackerannualPrice':'750',
        'upFront':'3,600',
        'maintenanceFee':'1,200',
        'engagemonthlyPrice':'499',
        'engageannualPrice':'5,400',
        'promonthlyPrice':'599',
        'proannualPrice':'6,450',
        'currency':'euro'
    }],
    ["22",
    {
        'coremonthlyPrice':'349',
        'coreannualPrice':'3,700',
        'trainmonthlyPrice':'499',
        'trainannualPrice':'5,400',
        'retainmonthlyPrice':'245',
        'retainannualPrice':'2,650',
        'jobTrackermonthlyPrice':'65',
        'jobTrackerannualPrice':'750',
        'upFront':'3,600',
        'maintenanceFee':'1,200',
        'engagemonthlyPrice':'499',
        'engageannualPrice':'5,400',
        'promonthlyPrice':'599',
        'proannualPrice':'6,450',
        'currency':'euro'
    }],
    ["152",
    {
        'coremonthlyPrice':'349',
        'coreannualPrice':'3,700',
        'trainmonthlyPrice':'499',
        'trainannualPrice':'5,400',
        'retainmonthlyPrice':'245',
        'retainannualPrice':'2,650',
        'jobTrackermonthlyPrice':'65',
        'jobTrackerannualPrice':'750',
        'upFront':'3,600',
        'maintenanceFee':'1,200',
        'engagemonthlyPrice':'499',
        'engageannualPrice':'5,400',
        'promonthlyPrice':'599',
        'proannualPrice':'6,450',
        'currency':'euro'
    }],
    ["152",
    {
        'coremonthlyPrice':'349',
        'coreannualPrice':'3,700',
        'trainmonthlyPrice':'499',
        'trainannualPrice':'5,400',
        'retainmonthlyPrice':'245',
        'retainannualPrice':'2,650',
        'jobTrackermonthlyPrice':'65',
        'jobTrackerannualPrice':'750',
        'upFront':'3,600',
        'maintenanceFee':'1,200',
        'engagemonthlyPrice':'499',
        'engageannualPrice':'5,400',
        'promonthlyPrice':'599',
        'proannualPrice':'6,450',
        'currency':'euro'
    }],
    ["201",
    {
        'coremonthlyPrice':'349',
        'coreannualPrice':'3,700',
        'trainmonthlyPrice':'499',
        'trainannualPrice':'5,400',
        'retainmonthlyPrice':'245',
        'retainannualPrice':'2,650',
        'jobTrackermonthlyPrice':'65',
        'jobTrackerannualPrice':'750',
        'upFront':'3,600',
        'maintenanceFee':'1,200',
        'engagemonthlyPrice':'499',
        'engageannualPrice':'5,400',
        'promonthlyPrice':'599',
        'proannualPrice':'6,450',
        'currency':'euro'
    }],
    ["208",
    {
        'coremonthlyPrice':'349',
        'coreannualPrice':'3,700',
        'trainmonthlyPrice':'499',
        'trainannualPrice':'5,400',
        'retainmonthlyPrice':'245',
        'retainannualPrice':'2,650',
        'jobTrackermonthlyPrice':'65',
        'jobTrackerannualPrice':'750',
        'upFront':'3,600',
        'maintenanceFee':'1,200',
        'engagemonthlyPrice':'499',
        'engageannualPrice':'5,400',
        'promonthlyPrice':'599',
        'proannualPrice':'6,450',
        'currency':'euro'
    }],
    ["97",
    {
        'coremonthlyPrice':'3,150',
        'coreannualPrice':'34,000',
        'trainmonthlyPrice':'4,700',
        'trainannualPrice':'50,750',
        'retainmonthlyPrice':'2,350',
        'retainannualPrice':'25,400',
        'jobTrackermonthlyPrice':'650',
        'jobTrackerannualPrice':'7,000',
        'upFront':'33,350',
        'maintenanceFee':'11,200',
        'engagemonthlyPrice':'4,700',
        'engageannualPrice':'50,750',
        'promonthlyPrice':'5,500',
        'proannualPrice':'59,400',
        'currency':'dollar'
    }],
    ["14",
    {
        'coremonthlyPrice':'530',
        'coreannualPrice':'5,725',
        'trainmonthlyPrice':'795',
        'trainannualPrice':'8,585',
        'retainmonthlyPrice':'395',
        'retainannualPrice':'4,265',
        'jobTrackermonthlyPrice':'115',
        'jobTrackerannualPrice':'1,240',
        'upFront':'5,640',
        'maintenanceFee':'1,890',
        'engagemonthlyPrice':'795',
        'engageannualPrice':'8,585',
        'promonthlyPrice':'925',
        'proannualPrice':'9,990',
        'currency':'dollar'
    }],
    ["1",
    {
        'coremonthlyPrice':'329',
        'coreannualPrice':'3,553',
        'trainmonthlyPrice':'549',
        'trainannualPrice':'5,929',
        'retainmonthlyPrice':'299',
        'retainannualPrice':'3,229',
        'jobTrackermonthlyPrice':'80',
        'jobTrackerannualPrice':'864',
        'upFront':'4,000',
        'maintenanceFee':'1,200',
        'engagemonthlyPrice':'499',
        'engageannualPrice':'5,389',
        'promonthlyPrice':'649',
        'proannualPrice':'7,009',
        'currency':'dollar'
    }]
]);
}